import { readyTopicNameBuilder } from ".";
import { Utils } from "./common";
class CustomElementBuilder {
  constructor(elementName) {
    this.object = {
      type: "vanilla",
      elementName,
      readyTopic: readyTopicNameBuilder(elementName),
      useShadowDOM: false,
      requireTokenBeforeLoad: [],
      javascript: [],
      css: [],
      observedAttributes: []
    };
  }
  useShadowDOM() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.object.useShadowDOM = value;
    return this;
  }
  reactApplicationElement() {
    this.object.type = "react";
    return this;
  }
  vueApplicationElement() {
    this.object.type = "vue";
    return this;
  }
  tokenRequiredBeforeLoad(tokenLogicName) {
    if (Array.isArray(tokenLogicName)) {
      tokenLogicName.forEach(tln => this.object.requireTokenBeforeLoad.push(tln));
    } else {
      this.object.requireTokenBeforeLoad.push(tokenLogicName);
    }
    return this;
  }
  withReadyTopic(topicName) {
    this.object.readyTopic = topicName;
    return this;
  }
  withJavascript(value, id, async) {
    if (typeof value === "string" && id !== undefined) {
      this.object.javascript.push({
        id,
        src: value,
        async: async === true
      });
    } else {
      this.object.javascript.push(value);
    }
    return this;
  }
  withRelativeJavascript(value, id, async) {
    if (typeof value === "string" && id !== undefined) {
      this.object.javascript.push({
        id,
        src: Utils.generateURLRelativeToScript(value),
        async: async === true
      });
    } else if (typeof value === "string") {
      this.object.javascript.push(Utils.generateURLRelativeToScript(value));
    } else if (typeof value === "object") {
      const valueCopy = JSON.parse(JSON.stringify(value));
      valueCopy.src = Utils.generateURLRelativeToScript(valueCopy.src);
      this.object.javascript.push(value);
    }
    return this;
  }
  withCss(value) {
    this.object.css.push(value);
    return this;
  }
  withRelativeCss(value) {
    this.object.css.push(Utils.generateURLRelativeToScript(value));
    return this;
  }
  withCustomElementClass(clazz) {
    this.object.elementClass = clazz;
    return this;
  }
  withObservedAttributes(attributes) {
    this.object.observedAttributes = attributes;
    return this;
  }
  build() {
    return this.object;
  }
}
class ConfigurationBuilder {
  constructor() {
    this.object = {
      autoLoadJavascript: [],
      autoLoadCss: [],
      customElements: [],
      singletons: [],
      tokenLogic: [],
      exposeApplicationSingletonsOnMD: false
    };
  }
  withApplicationSingleton(name, builder) {
    this.object.singletons.push({
      name,
      builder
    });
    return this;
  }
  withTokenLogic(name, tokenProvider, triggerCallback) {
    this.object.tokenLogic.push({
      name,
      tokenProvider,
      triggerCallback
    });
    return this;
  }
  withJavascript(value, id, async) {
    if (typeof value === "string" && id !== undefined) {
      this.object.autoLoadJavascript.push({
        id,
        src: value,
        async: async === true
      });
    } else {
      this.object.autoLoadJavascript.push(value);
    }
    return this;
  }
  withRelativeJavascript(value, id, async) {
    if (typeof value === "string" && id !== undefined) {
      this.object.autoLoadJavascript.push({
        id,
        src: Utils.generateURLRelativeToScript(value),
        async: async === true
      });
    } else if (typeof value === "string") {
      this.object.autoLoadJavascript.push(Utils.generateURLRelativeToScript(value));
    } else if (typeof value === "object") {
      const valueCopy = JSON.parse(JSON.stringify(value));
      valueCopy.src = Utils.generateURLRelativeToScript(valueCopy.src);
      this.object.autoLoadJavascript.push(value);
    }
    return this;
  }
  withCss(value) {
    this.object.autoLoadCss.push(value);
    return this;
  }
  withRelativeCss(value) {
    this.object.autoLoadCss.push(Utils.generateURLRelativeToScript(value));
    return this;
  }
  withCustomElement(builder) {
    const customElement = builder(elementName => new CustomElementBuilder(elementName));
    this.object.customElements.push(customElement);
    return this;
  }
  exposeApplicationSingletonsOnMD() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.object.exposeApplicationSingletonsOnMD = value;
    return this;
  }
  build() {
    return this.object;
  }
}
export const configurationBuilder = () => new ConfigurationBuilder();